import { render } from "./GibergCreators.vue?vue&type=template&id=27cc46e5&scoped=true"
import script from "./GibergCreators.vue?vue&type=script&lang=js"
export * from "./GibergCreators.vue?vue&type=script&lang=js"

import "./GibergCreators.vue?vue&type=style&index=0&id=27cc46e5&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27cc46e5"]])

export default __exports__